import React from "react";
import CreateOrder from "src/components/orders/create/CreateOrder";

export default function CreateOrderPage() {
  return <CreateOrder />;
}
